<template>
  <div id="questionstree" class="questionstree" v-loading.body="loading">
    <div style="height:100%;">
      <el-tree
        style="height:100%;padding:5px;overflow-y:scroll;"
        :props="properties"
        :load="loadNodes"
        :accordion="true"
        :show-checkbox="true"
        :highlight-current="true"
        :render-content="renderContent"
        lazy
        >
      </el-tree>
    </div>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  import layout from '../../api/helpers/layout'

  export default {
    name: 'questionstree',
    data() {
      return {
        resultsHeight: null,
        loading: false,
        properties: {
          label: 'label',
          children: 'children',
          isLeaf: 'isLeaf'
        }
      }
    },
    computed: {
      resultsTableHeight: function() {
        if(!this.resultsHeight) {
          let height = layout.getParentClientHeight();
          if(height)
            return height - 30 - 50;
        }
        return this.resultsHeight;
      }
    },
    methods: {
      fetchData: function(parent, resolve) {
        let self = this;
        let prefix = config.API_PREFIX;
        this.loading = true;
        this.$gf.getOptions().then(options => {
          options.params = {
          };
          let get = parent ? (`${prefix}hierarchy/tree/` + parent) : `${prefix}hierarchy/tree`
          self.$http.get(get, options)
            .then(response => {
              this.loading = false;
              resolve(response.data);
            })
            .catch(data => {
              self.$gf.checkError(data);
              this.loading = false;
            })
        }).catch(err => {
          this.$gf.catchOptions();
          this.loading = false;
        });
      },
      loadNodes(node, resolve) {
        this.fetchData(node.level === 0 ? null : node.data.uid, resolve);
      },
      renderContent(h, { node, data, store }) {
        let type = node.data.elementType;
        let clazz = type == 1 ? "el-icon-menu" : (type == 2 ? "el-icon-document" : "");
        let count = node.data.questionCount ? ("("+node.data.questionCount+")") : "";
        return h('span', [
          h('i', {
            attrs: {
              class: clazz,
              style: "padding-right: 7px;"
            }
          }),
          h('span', {
              attrs: {
                style: "font-size: 14px;font-weight: bold;padding-right: 7px;"
              }
            }, count),
          h('span', {
            attrs: {
              style: "font-size: 14px;"
            }
          }, node.label)
        ]);
      },
      resize() {
        let height = layout.getParentClientHeight();
        if(height)
          this.resultsHeight = height - 30;
        else
          this.resultsHeight = null;
      }
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.resize);
    },
    created: function () {
      window.addEventListener('resize', this.resize);
    }
  }
</script>

<style scoped>
  .questionstree {
    height: calc(100% - 20px);
    background: #eef1f6;
    border: 1px solid #d1dbe5;
  }
  .middle-aligned {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
</style>
<style>
  .el-tree-node__content .el-tree-node__expand-icon,
  .el-tree-node__content .el-checkbox {
    margin-top: -9px;
  }
</style>



// WEBPACK FOOTER //
// src/components/operational/questionstree.vue